import { z } from "zod";

const TotalSchema = z.object({
    total_property: z.number(),
    billing_type: z.record(z.string(), z.number()),
    property_type: z.record(z.string(), z.number()),
    // Sum of active room counts (status = available) across active vacation_rental
    // properties — same definition as the property list's Total Room column.
    total_room_vacation_rental: z.number().optional(),
});

const MonthlyPropertyCreationSchema = z.object({
    month: z.number(),
    total: z.number(),
});

const PropertyStatisticsDataSchema = z.object({
    total: TotalSchema,
    monthly_property_creation: z.array(MonthlyPropertyCreationSchema),
    city_distribution: z.record(z.string(), z.number()),
});

export const PropertyStatisticsResponse = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: PropertyStatisticsDataSchema,
});